import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";



export const getPromptFiltersData = createAsyncThunk(
    "promptFilters",
    async (args, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.promptFilters, args);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

export const promptFiltersDataSlice = createSlice({
    name: "promptFilters",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        promptFiltersDataReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            }
        }
    },
     extraReducers: {
            [getPromptFiltersData.fulfilled]: (state, { payload }) => {
                state.isLoading = false;
                state.success = true;
                state.data = payload;
                state.error = false;
            },
            [getPromptFiltersData.pending]: (state) => {
                state.isLoading = true;
                state.data = false;
                state.error = null;
            },
            [getPromptFiltersData.rejected]: (state, { payload }) => {
                state.isLoading = false;
                state.error = payload;
                state.success = false;
            },
        }
})

export const { promptFiltersDataReset } = promptFiltersDataSlice.actions;